class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.toggleShowMore.bind(this));
  }

  toggleShowMore() {
    this.closest('.mobile-facets__submenu')?.classList.toggle('mobile-facets__submenu--show-all')
  }
}

customElements.define('show-more-button', ShowMoreButton);

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);


  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {


    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML

    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;



    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    // Create FormData object from the form
    const formData = new FormData(form);

    // dont apply price filter if min is empty and max is default max or both are empty
    const priceInputMax = form.querySelector('input.field-input--max')?.max;
    let maxKeyValue = null;
    let minKeyValue = null;
    formData.forEach((value, key) => {
      if (key === 'filter.v.price.lte') {
        maxKeyValue = value;
      }
      if (key === 'filter.v.price.gte') {
        minKeyValue = value;
      }
    });
    if( (minKeyValue == '' && maxKeyValue == priceInputMax) || (minKeyValue == 0 && maxKeyValue == priceInputMax) || (minKeyValue == '' && maxKeyValue == '')) {
      formData.delete('filter.v.price.gte');
      formData.delete('filter.v.price.lte');
    }

    // Convert FormData to URLSearchParams string
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');

    const forms = [];
    let isMobile = window.innerWidth < 750

    window.matchMedia("(max-width: 749px)").addEventListener('change', (e) => {
      if (e.matches) {
        isMobile = true;
      } else {
        isMobile = false;
      }
    });

    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortDrawerForm') {
          const noJsElements = document.querySelectorAll('.no-js-list');
          noJsElements.forEach((el) => el.remove());
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });

    this.onSubmitForm(forms.join('&'), event)
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();

    const inputs = this.querySelectorAll('.field__input');
    this.minInput = inputs[0];
    this.maxInput = inputs[1];

    inputs.forEach(input => {
      input.addEventListener('change', () => this.syncFromInputs());

      // Format to 2 decimals when user finishes typing
      input.addEventListener('blur', () => {
        if (input.value !== '') {
          input.value = parseFloat(input.value).toFixed(2);
        }
      });
    });

    this.slider = this.querySelector('.js-range-slider');
    if (this.slider) this.initSlider();

    this.setMinAndMaxValues();
  }

  initSlider() {
    const minHandle = this.slider.querySelector('.range-handle--min');
    const maxHandle = this.slider.querySelector('.range-handle--max');
    const rangeTrack = this.slider.querySelector('.range-range');

    const sliderMin = Number(this.slider.dataset.min);
    const sliderMax = Number(this.slider.dataset.max);

    [minHandle, maxHandle].forEach(handle => {
      handle.min = sliderMin;
      handle.max = sliderMax;

      handle.addEventListener('input', () => {
        const minValue = Math.min(+minHandle.value, +maxHandle.value);
        const maxValue = Math.max(+minHandle.value, +maxHandle.value);

        minHandle.value = minValue;
        maxHandle.value = maxValue;

        // Display formatted values
        this.minInput.value = minValue ? minValue.toFixed(2) : '';
        this.maxInput.value = maxValue ? maxValue.toFixed(2) : '';

        const minPercent =
          ((minValue - sliderMin) / (sliderMax - sliderMin)) * 100;
        const maxPercent =
          ((maxValue - sliderMin) / (sliderMax - sliderMin)) * 100;

        rangeTrack.style.left = minPercent + '%';
        rangeTrack.style.width = maxPercent - minPercent + '%';

        this.dispatchEvent(
          new CustomEvent('rangeChange', { bubbles: true })
        );
      });
    });

    this.syncFromInputs();
  }

  syncFromInputs() {
    if (!this.slider) return;

    const minHandle = this.slider.querySelector('.range-handle--min');
    const maxHandle = this.slider.querySelector('.range-handle--max');

    minHandle.value = this.minInput.value
      ? parseFloat(this.minInput.value)
      : minHandle.min;

    maxHandle.value = this.maxInput.value
      ? parseFloat(this.maxInput.value)
      : maxHandle.max;

    // Trigger slider update
    minHandle.dispatchEvent(new Event('input'));
  }

  setMinAndMaxValues() {
    if (this.maxInput.value) {
      this.minInput.max = parseFloat(this.maxInput.value);
    }
    if (this.minInput.value) {
      this.maxInput.min = parseFloat(this.minInput.value);
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
    if (this.hasAttribute('data-clear-all')) {
      // close drawer on clear all click
      facetLink.addEventListener('click', () => {
        const menuDrawer = this.closest('menu-drawer');
        if (menuDrawer) {
          menuDrawer.closeMenuDrawer('close');
        }
      });
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
